export const Required_Icon = <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M3.864 0.879999L3.624 3.184L5.928 2.536L6.096 3.64L3.888 3.82L5.316 5.716L4.284 6.28L3.264 4.18L2.34 6.28L1.272 5.716L2.676 3.82L0.492 3.64L0.66 2.536L2.94 3.184L2.688 0.879999H3.864Z" fill="#E03923" />
</svg>
